import React from 'react';

import { AgentDialogueLoader } from '@/components/Common/Loader';
import { HistoryStore } from '@/stores/history';
import { inject, observer } from 'mobx-react';
import { getTrans, replaceParams } from '@/utils/tools';
import { FAKE_SESSION_ID, HISTORY_TRANSIFY_KEY, MAX_SHOW_HISTORY_DAYS, TRACKING_TYPE } from '@/utils/constants';
import { addObserver, removeObserver } from '@/utils/intersectionObserver';
import { PullToLoadStatus } from '@/components/PullToLoad';
import { HISTORY_STATUS } from '@/types/history';

import { getChildInject } from '@/utils/instantLoaded/tools';
import './style.scss';

const PREFIX = 'history-loader';

export interface HistoryLoaderProps {
  historyStore: HistoryStore;
  initStore: any;
  status: any;
}

export interface HistoryLoaderState {
  currentStatus: any;
}

const Loading = () => <AgentDialogueLoader />;
const NoMoreHistory = () => <div className="no-more">{getTrans(HISTORY_TRANSIFY_KEY.NO_MORE_HISTORY)}</div>;
const NoMoreHistoryThan180 = () => (
  <div>
    <div className="no-more">{getTrans(HISTORY_TRANSIFY_KEY.NO_MORE_HISTORY)}</div>
    <div className="no-more">{replaceParams(getTrans(HISTORY_TRANSIFY_KEY.NO_MORE_HISTORY_IN_X_DAYS), { x: MAX_SHOW_HISTORY_DAYS })}</div>
  </div>
);

@inject(getChildInject('initStore', 'historyStore'))
@observer
class HistoryLoader extends React.Component<HistoryLoaderProps, HistoryLoaderState> {
  static defaultProps = { historyStore: {}};

  trackingname = [TRACKING_TYPE.LOADING_HISTORY, TRACKING_TYPE.NO_MORE_MESSAGE, TRACKING_TYPE.NO_MORE_MESSAGE_EXCEED_DURATION];
  trackingdata = {};
  loaderRef = React.createRef<HTMLDivElement>();

  constructor(props: HistoryLoaderProps) {
    super(props);

    const sessionId = this.props.initStore.sessionId;

    this.trackingdata = { current_chat_session_id: sessionId === FAKE_SESSION_ID ? '0' : sessionId };

    this.state = { currentStatus: 'pending' };
  }

  componentDidMount() {
    // 只有显示除加载中 或 状态为无更多数据 才addobserver
    if (this.props.status === PullToLoadStatus.ACTIVE || this.props.historyStore.historyStatus !== HISTORY_STATUS.HAS_MORE_HISTORY) {
      addObserver(this.loaderRef.current);
    }
  }

  componentWillUnmount() {
    removeObserver(this.loaderRef.current);
  }

  render() {
    const { historyStatus } = this.props.historyStore;
    const renderList = [Loading, NoMoreHistory, NoMoreHistoryThan180];

    return (
      <div
        ref={this.loaderRef}
        className={PREFIX}
        data-trackingname={this.trackingname[historyStatus]}
        data-trackingdata={JSON.stringify(this.trackingdata)}
      >
        {renderList[historyStatus]()}
      </div>
    );
  }
}

export default HistoryLoader;
